import _defineProperty from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "E:\\FIVER284-paralight\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { v4 as U } from "uuid";
function F() {
  return U();
}
var x = function (o) {
    return o.reactUi = "client-sdk-react-ui", o.vanillaUi = "client-sdk-vanilla-ui", o;
  }(x || {}),
  D = function (n) {
    return n.prod = "https://www.crossmint.io", n.staging = "https://staging.crossmint.io/", n.dev = "http://localhost:3001", n;
  }(D || {}),
  X = function (o) {
    return o.clientVersion = "X-Client-Version", o.clientName = "X-Client-Name", o;
  }(X || {}),
  Z = function Z(t) {
    return t === "ETH";
  },
  tt = function tt(t) {
    return t === "SOL";
  },
  L = function (n) {
    return n.CANDY_MACHINE = "candy-machine", n.SOLANA_AUCTION = "solana-auction", n.ERC_721 = "erc-721", n;
  }(L || {}),
  A = function (r) {
    return r.WAITING_SUBMISSION = "waiting-submission", r.PENDING = "pending", r.REJECTED = "rejected", r.ACCEPTED = "accepted", r.INVALID = "invalid", r;
  }(A || {});
var y = function y() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var e = ["prod", "production"];
  return t === "staging" ? "https://staging.crossmint.io/" : e.includes(t) || !t ? "https://www.crossmint.io" : t;
};
var M = "__crossmint-overlay__",
  H = 400,
  R = 750,
  W = function W() {
    var t = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return t ? parseInt(t[2]) : null;
  };
function k(t, e) {
  function o() {
    return (window == null ? void 0 : window.top) != null ? window.top.outerWidth / 2 + window.top.screenX - t / 2 : window.outerWidth / 2 + window.screenX - t / 2;
  }
  function n() {
    return (window == null ? void 0 : window.top) != null ? window.top.outerHeight / 2 + window.top.screenY - e / 2 : window.outerHeight / 2 + window.screenY - e / 2;
  }
  var i = W();
  return "".concat(i && i > 99 ? "popup=true," : "", "height=").concat(e, ",width=").concat(t, ",left=").concat(o(), ",top=").concat(n(), ",resizable=yes,scrollbars=yes,toolbar=yes,menubar=true,location=no,directories=no, status=yes");
}
var G = function G(t) {
    var e = document.createElement("div");
    e.setAttribute("id", M);
    var o = {
      width: "100vw",
      height: "100vh",
      "background-color": "rgba(0, 0, 0, 0.5)",
      position: "fixed",
      "z-index": "99999999",
      top: "0",
      left: "0"
    };
    Object.assign(e.style, o), document.body.appendChild(e), t && e.addEventListener("click", function () {
      O();
    });
  },
  O = function O() {
    var t = document.getElementById(M);
    t && t.remove();
  };
function rt(_ref) {
  var t = _ref.clientId,
    e = _ref.libVersion,
    o = _ref.showOverlay,
    n = _ref.dismissOverlayOnClick,
    i = _ref.setConnecting,
    r = _ref.environment,
    l = _ref.clientName,
    s = _ref.locale,
    f = _ref.currency;
  var E = function E(m, p, S, I, h, C, v, B) {
      var N = y(r),
        _ = encodeURIComponent("".concat(N, "/checkout/mint?").concat(function () {
          var g = {
            clientId: t,
            clientName: l,
            clientVersion: e,
            mintConfig: JSON.stringify(m),
            locale: s,
            currency: f
          };
          return p && (g.mintTo = p), S && (g.emailTo = S), I && (g.listingId = I), h && (g.whPassThroughArgs = JSON.stringify(h)), C && (g.paymentMethod = C.toLowerCase()), v && (g.preferredSigninMethod = v), B && (g.prepay = "true"), new URLSearchParams(g).toString();
        }())),
        w = "".concat(N, "/signin?callbackUrl=").concat(_),
        b = window.open(w, "popUpWindow", k(H, R));
      if (b) {
        c(b), o && G(n);
        return;
      }
      i(!1), window.open(w, "_blank") || console.error("Failed to open popup window and new tab");
    },
    P = function P(m, p, S, I, h, C, v, B) {
      i(!0), E(m, p, S, I, h, C, v, B);
    };
  function c(m) {
    var p = setInterval(function () {
      m.closed && (clearInterval(p), i(!1), o && O());
    }, 500);
  }
  return {
    connect: P
  };
}
var V = {
    crossmintPayButtonService: {
      CONNECTING: "Connecting...",
      BUY_WITH_ETH: "Buy with ETH",
      BUY_WITH_SOL: "Buy with SOL",
      BUY_WITH_CREDIT_CARD: "Buy with credit card"
    },
    crossmintStatusButtonService: {
      INVALID: "Invalid clientId",
      WAITING_SUBMISSION: "Click here to setup Crossmint",
      PENDING: "Your application is under review",
      ACCEPTED: "You're good to go!",
      REJECTED: "Your application was rejected"
    }
  },
  Y = {
    crossmintPayButtonService: {
      CONNECTING: "Conectando...",
      BUY_WITH_ETH: "Comprar con ETH",
      BUY_WITH_SOL: "Comprar con SOL",
      BUY_WITH_CREDIT_CARD: "Comprar con tarjeta de cr\xE9dito"
    },
    crossmintStatusButtonService: {
      INVALID: "clientId inv\xE1lido",
      WAITING_SUBMISSION: "Haga clic aqu\xED para configurar Crossmint",
      PENDING: "Su solicitud est\xE1 en revisi\xF3n",
      ACCEPTED: "\xA1Est\xE1 listo para usar Crossmint!",
      REJECTED: "Su solicitud fue rechazada"
    }
  },
  $ = {
    "en-US": V,
    "es-ES": Y
  };
function a(t, e) {
  var o = $[e];
  return t.split(".").reduce(function (n, i) {
    return n[i];
  }, o);
}
function ct(_ref2) {
  var t = _ref2.onClick,
    e = _ref2.connecting,
    o = _ref2.paymentMethod,
    n = _ref2.locale;
  return {
    getButtonText: function getButtonText(s) {
      if (s) return a("crossmintPayButtonService.CONNECTING", n);
      switch (o) {
        case "ETH":
          return a("crossmintPayButtonService.BUY_WITH_ETH", n);
        case "SOL":
          return a("crossmintPayButtonService.BUY_WITH_SOL", n);
        default:
          return a("crossmintPayButtonService.BUY_WITH_CREDIT_CARD", n);
      }
    },
    shouldHideButton: function shouldHideButton(_ref3) {
      var s = _ref3.hideMintOnInactiveClient,
        f = _ref3.status;
      return s && f !== "accepted";
    },
    handleClick: function handleClick(s, f) {
      t && t(s), !e && (s.defaultPrevented || f());
    }
  };
}
var Q = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function T(t) {
  return typeof t == "string" && Q.test(t);
}
var J = function J(t) {
  try {
    return T(t);
  } catch (e) {
    return console.error(e), !1;
  }
};
function pt(_ref4) {
  var t = _ref4.libVersion,
    e = _ref4.clientId,
    o = _ref4.platformId,
    n = _ref4.auctionId,
    i = _ref4.mintConfig,
    r = _ref4.setStatus,
    l = _ref4.environment,
    s = _ref4.clientName;
  function f() {
    return _f.apply(this, arguments);
  }
  function _f() {
    _f = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _headers;
      var c, m, p;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!e || e === "" || e === "<YOUR_CLIENT_ID>")) {
              _context.next = 3;
              break;
            }
            console.error("You must enter your own Crossmint client ID in <CrossmintPayButton clientId=XXX>");
            return _context.abrupt("return");
          case 3:
            if (J(e)) {
              _context.next = 6;
              break;
            }
            console.error("The clientId passed to is invalid. Make sure to pass the clientId obtained from the crossmint team, with format XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXX");
            return _context.abrupt("return");
          case 6:
            c = y(l);
            _context.next = 9;
            return fetch("".concat(c, "/api/crossmint/onboardingRequests/").concat(e, "/status"), {
              headers: (_headers = {}, _defineProperty(_headers, "X-Client-Version", t), _defineProperty(_headers, "X-Client-Name", s), _headers)
            });
          case 9:
            m = _context.sent;
            if (!(m.status === 200)) {
              _context.next = 17;
              break;
            }
            _context.next = 13;
            return m.json();
          case 13:
            p = _context.sent;
            r(p.status);
            _context.next = 18;
            break;
          case 17:
            r("invalid");
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _f.apply(this, arguments);
  }
  var E = function E() {
      var c = y(l);
      window.open("".concat(c, "/developers/onboarding?").concat(P()), "_blank");
    },
    P = function P() {
      var c = {
        clientId: e
      };
      return o && (c.platformId = o), n && (c.auctionId = n), i && (c.mintConfig = JSON.stringify(i)), new URLSearchParams(c).toString();
    };
  return {
    fetchClientIntegration: f,
    goToOnboarding: E
  };
}
function yt(_ref5) {
  var t = _ref5.onClick,
    e = _ref5.locale;
  return {
    getButtonText: function getButtonText(r) {
      switch (r) {
        case "invalid":
          return a("crossmintStatusButtonService.INVALID", e);
        case "waiting-submission":
          return a("crossmintStatusButtonService.WAITING_SUBMISSION", e);
        case "pending":
          return a("crossmintStatusButtonService.PENDING", e);
        case "accepted":
          return a("crossmintStatusButtonService.ACCEPTED", e);
        case "rejected":
          return a("crossmintStatusButtonService.REJECTED", e);
      }
    },
    isButtonDisabled: function isButtonDisabled(r) {
      return r !== "waiting-submission";
    },
    handleClick: function handleClick(r, l, s) {
      t && t(r), l === "waiting-submission" && s();
    }
  };
}
export { D as baseUrls, x as clientNames, rt as crossmintModalService, ct as crossmintPayButtonService, yt as crossmintStatusButtonService, pt as crossmintStatusService, X as customHeaders, F as generateClientId, L as mintingContractTypes, A as onboardingRequestStatusResponse, Z as paymentMethodIsEth, tt as paymentMethodIsSol };